






import Vue from 'vue'
import { HistoryItemOptionData } from '@/models/scripts'

interface Computed {
  color: string
  containerStyle: Record<string, string>
  optionStyle: Record<string, string>
  textStyle: Record<string, string>
}

interface Props {
  data: HistoryItemOptionData
}

export default Vue.extend<{}, {}, Computed, Props>({
  props: {
    data: {
      required: true,
    },
  },
  computed: {
    color() {
      return `#${this.data.c}`
    },
    containerStyle() {
      return { borderColor: this.color }
    },
    optionStyle() {
      return { backgroundColor: this.color }
    },
    textStyle() {
      return { color: this.color }
    },
  },
})
